import { ClientConfigurationReducer } from './client-configuration.reducer';

export const reducers = ClientConfigurationReducer;
